import cx from 'clsx';
import { FC } from 'react';
import { Footer } from 'src/components/Footer';
import { Header } from 'src/components/Header';
import { MediaGrid } from 'src/components/MediaGrid';
import { MediaPreview } from 'src/components/MediaPreview';
import { TagBox } from 'src/components/TagBox';

import mainStyles from '../../styles.module.css';
import styles from './styles.module.css';

export const ResultStep: FC = () => (
  <section className={cx(mainStyles.stepSection, styles.container)}>
    <Header />

    <h3 className={styles.text}>
      Your video is <span className={styles.highlight}>ready!</span>
    </h3>
    <MediaGrid />
    <TagBox />
    <MediaPreview />
    <Footer />
  </section>
);
